<template>
  <div class="box">
    <div :class="[titleStyle]">
      <div v-if="!isYZMLogin">账号登录</div>
      <div v-if="isYZMLogin">手机号登录</div>
    </div>
    <div v-if="!isYZMLogin">
      <p v-if="loginway===1?true:false" style="cursor:pointer" @click="changeLogin">手机号短信登录</p>
      <div class="input">
        <div class="input-img"><img src="../../../static/images/loginicon1.png" class="imgsize" alt="图标"></div>
        <b-form-input v-model="name" placeholder="用户名" class="input-name" />
      </div>
      <div class="input">
        <div class="input-img"><img src="../../../static/images/loginicon2.png" class="imgsize" alt="图标"></div>
        <b-form-input v-model="password" type="password" placeholder="密码" class="input-password" />
      </div>
      <div class="checkbox">
        <input v-model="rememberPwd" class="checkbox" type="checkbox" value="">记住密码
      </div>
    </div>
    <div v-if="isYZMLogin">
      <p v-if="loginway===1?true:false" style="cursor:pointer" @click="changeLogin">用户名密码登录</p>
      <div class="input">
        <div class="input-img"> <img src="../../../static/images/loginicon4.png" alt="图标"></div>
        <b-form-input v-model="name" placeholder="请输入手机号" class="input-phone" />
      </div>
      <div class="layout-flex">
        <div class="input1">
          <div class="input1-img"><img src="../../../static/images/loginicon5.png" alt="图标"></div>
          <b-form-input v-model="YZM" type="password" placeholder="请输入验证码" class="input-YZM" />
        </div>
        <span>
          <div v-if="doGetYZM" class="button-yzm" @click="getYZM">获取验证码</div>
          <div v-if="!doGetYZM" class="button-yzm-ban">请{{ count }}秒后重试</div>
        </span>
      </div>
    </div>
    <button
      :class="[buttonStyle]"
      @click="load"
    >
      登&nbsp;&nbsp;录</button>
    <img src="../../../static/images/loginicon3.png" class="box-icon" alt="图标">
  </div>
</template>
<script>
export default {
  props: {
    loginway: {
      type: Number,
      default: null
    },
    ispassyzm: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      rememberPwd: false,
      doGetYZM: true,
      count: 60,
      isYZMLogin: false,
      titleStyle: 'title-red',
      buttonStyle: 'button-red',
      name: '',
      password: '',
      YZM: '',
      boxloginway: this.loginway,
      loginTerminal: true,
      loginShop: false,
      loginManage: false
    }
  },
  computed: {
    tmpLoginWay: function () {
      return this.loginway
    }
  },
  watch: {
    rememberPwd (newV, oldV) {
      this.$emit('rememberPwd', newV)
    },
    ispassyzm (newV, oldV) {
      console.log('newv+++++++', newV)
      if (newV) {
        console.log('进行倒计时+++++++')
        this.count = 60
        this.doGetYZM = false
        this.countDown()
      }
    },
    loginway (newV, oldV) {
      switch (newV) {
        case 1:
          this.titleStyle = 'title-red'
          this.buttonStyle = 'button-red'
          break
        case 2:
          this.titleStyle = 'title-yellow'
          this.buttonStyle = 'button-yellow'
          this.isYZMLogin = false
          break
        case 3:
          this.titleStyle = 'title-blue'
          this.buttonStyle = 'button-blue'
          this.isYZMLogin = false
          break
      }
    }
  },
  mounted () {
    this.getCookie()
  },
  methods: {
    getCookie () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ')
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') // 再次切割
          // 判断查找相对应的值
          if (arr2[0] === 'userName') {
            this.name = arr2[1] // 保存到保存数据的地方
          } else if (arr2[0] === 'userPwd') {
            this.password = arr2[1]
          }
        }
      }
      console.log(this.name, this.password)
    },
    changeLogin () {
      this.isYZMLogin = !this.isYZMLogin
      this.name = ''
      this.password = ''
      this.YZM = ''
    },
    load () {
      if (this.isYZMLogin) {
        this.$emit('login', this.name, this.YZM, true)
      } else {
        this.$emit('login', this.name, this.password, false)
      }
    },
    getYZM () {
      this.$emit('getYZM', this.name)
    },
    countDown () {
      // 验证码倒计时
      if (this.count >= 1) {
        this.count = this.count - 1
        setTimeout(this.countDown, 1000)
        if (this.count === 0) {
          this.doGetYZM = !this.doGetYZM
          this.$emit('countDown')
        }
      }
    }
  }
}
</script>
<style scoped>
  .box{
    width: 100%;
    height: 100%;
     background-color: #ffffff;
  }
  .input{
    text-align: left;
    margin:0px auto 20px;
    width: 350px;
    height: 43px;
    border:1px solid #cccccc
  }
  .input1{
    text-align: left;
    margin:0px 25px 20px;
    width: 200px;
    height: 43px;
    border:1px solid #cccccc
  }

  .input-img{
    margin-left: 20px;
    margin-top: 10px;
    width: 24px;
    height: 24px;
  }
   .imgsize{
    width: 24px;
    height: 24px;
  }
   .input1-img{
    margin-left: 18px;
    margin-top: 10px;
    width: 24px;
    height: 24px;
  }
  .input-name{
    margin-top: -34px;
    border: 0px;
    width: 297px;
    margin-left: 50px;
  }
  .input-phone{
    margin-top: -34px;
    border: 0px;
    width: 297px;
    margin-left: 50px;
  }
  .input-YZM{
    margin-top: -34px;
    border: 0px;
     width: 150px;
    margin-left: 50px;
  }
  .input-password{
    margin-top: -32px;
    border: 0px;
     width: 297px;
    margin-left: 50px;
  }
  .title-red{
    line-height: 86px;
    text-align: left;
    font-size: 28px;
    margin-left: 30px;
    color: #e62229;
  }
  .title-blue{
    line-height: 86px;
    text-align: left;
    font-size: 28px;
    margin-left: 30px;
    color: #009be7;
  }
  .title-yellow{
    line-height: 86px;
    text-align: left;
    font-size: 28px;
    margin-left: 30px;
    color: #fda421;
  }
  .button-red{
    width: 350px;
    height: 45px;
    margin: 0px auto;
    border: 0px solid transparent;
    color: #ffffff;
    text-align: center;
    font-weight: 800;
    background-color: #e62129;
    margin-top: 20px;
    font-size: 18px;
  }
  .button-blue{
    width: 350px;
    height: 45px;
    margin: 0px auto;
    border: 0px solid transparent;
    color: #ffffff;
    text-align: center;
    font-weight: 800;
    background-color: #009be7;
    margin-top: 20px;
    font-size: 18px;
  }
  .button-yellow{
    width: 350px;
    height: 45px;
    margin: 0px auto;
    border: 0px solid transparent;
    color: #ffffff;
    text-align: center;
    font-weight: 800;
    background-color: #fda41f;
    margin-top: 20px;
    font-size: 18px;
  }
  .checkbox{
    color: #000000;
    text-align: left;
    margin-left: 15px;
    font-size: 14px;
  }
  .box-icon{
    margin-top: 30px;
  }
  .layout-flex{
    display: flex;
  }
  .button-yzm{
    width: 150px;
    height: 45px;
    background-color:#e62129;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    line-height: 45px;
    margin-left: -25px;
    margin-top: -1.5px;
  }
  .button-yzm-ban{
     width: 150px;
    height: 45px;
    background-color:gray;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    line-height: 45px;
    margin-left: -25px;
    margin-top: -1.5px;
  }
  p:hover{
   color: 009cff;
   text-decoration:underline;
}
p{
  color: #009cff;
  font-size: 14px;
  margin-left: 250px;
  margin-top: -25px;
}
</style>
